import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { DisplayConditionType } from '../../shared/domain/display.condition.type';
import { ItemService } from './item/item.service';
import { DisplayCondition } from '../../shared/domain/DisplayCondition';
import { FormGroupWrapper } from '../../shared/domain/FormGroupWrapper';
import { Configuration } from '../../shared/domain/configuration.model';

@Component({
  selector: 'cc-display-condition-list',
  templateUrl: './display-condition-list.component.html',
  styleUrls: ['./display-condition-list.component.scss']
})
export class DisplayConditionListComponent implements OnInit {
  @Input() public displayConditionsFormWrapper: FormGroupWrapper;
  @Input() private configuration: Configuration;

  constructor(private formBuilder: FormBuilder, private itemService: ItemService) {}

  ngOnInit() {
    this.createDisplayConditionsForm();

    if (!this.getDisplayConditionsFormArray.length) {
      this.createNewDisplayCondition();
    }
  }

  get leadGenerationConfig() {
    return this.configuration;
  }

  get getDisplayConditionsFormArray() {
    return this.displayConditionsFormWrapper.form.get('displayConditions') as FormArray;
  }

  changeDisplayConditionEnabling(event) {
    this.leadGenerationConfig.displayConditionsEnabled = event;
  }

  createDisplayConditionsForm() {
    const displayConditionsToForm = this.leadGenerationConfig.displayConditions.map(item =>
      this.prepareDisplayCondition(item)
    );

    this.displayConditionsFormWrapper.form = this.formBuilder.group({
      displayConditions: this.formBuilder.array(displayConditionsToForm),
      displayConditionsLogicalOperator: this.leadGenerationConfig.displayConditionsLogicalOperator
    });
  }

  prepareDisplayCondition(displayConditions: DisplayCondition) {
    return this.itemService.createForm(displayConditions);
  }

  createNewDisplayCondition() {
    this.createDisplayCondition(
      this.prepareDisplayCondition({ type: DisplayConditionType.CURRENT_PAGE } as DisplayCondition)
    );
  }

  createDisplayCondition(formGroup: FormGroup) {
    this.getDisplayConditionsFormArray.push(formGroup);
  }

  get showRemovalIcon() {
    return this.getDisplayConditionsFormArray.length > 1;
  }

  deleteDisplayCondition(index) {
    this.getDisplayConditionsFormArray.removeAt(index);
  }
}
